import { render, staticRenderFns } from "./Liquidadores.vue?vue&type=template&id=0527ccd2&"
import script from "./Liquidadores.vue?vue&type=script&lang=js&"
export * from "./Liquidadores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports